import axios from 'axios'
import { errorMessage } from '~/services/messager'
import { Auth } from 'aws-amplify'
import { warningMessage } from './messager'

const api = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
})

api.interceptors.request.use(async (config) => {
	// in case there is a logged in user, get the token from amplify auth
	// and add it as an atuh beare token to the api
	try {
		// Login legado!
		let session = null
		let jwtToken = null
		try {
			session = await Auth.currentSession()
			const accessToken = session.getIdToken()
			jwtToken = accessToken.getJwtToken()
		} catch (erroAuth) {
			// console.log("1 ::: ", erroAuth)
			const userContracts = JSON.parse(localStorage.getItem('user-contracts'))
			jwtToken = userContracts?.accessToken
			// console.log("TOKEN .... 1 ::: ", jwtToken)
		}

		config.headers['Authorization'] = `Bearer ${jwtToken}`
		config.headers['Content-Type'] = 'application/json'
		config.headers['Accept'] = 'application/json'
	} catch (error) {
		console.log(error)
	}
	return config
})

api.interceptors.response.use(
	(response) => {
		return response
	},
	(error) => {
		const originalRequest = error.config

		if (!window.navigator.onLine) {
			errorMessage({
				content:
					'Não conseguimos contato com nossos servidores. O dispositivo está conectado?',
			})
		} else if (error.response.status === 401) {
			localStorage.clear()
			warningMessage({
				content:
					'Sua sessão expirou. Faça login novamente para acessar a plataforma.',
			})
			window.location = '/'

			// originalRequest._retry = true

			// try {
			// 	const userContracts = JSON.parse(localStorage.getItem('user-contracts'))
			// 	const refreshToken = userContracts.refreshToken

			// TODO: call refresh token api endpoint to get new access token
			// const newToken = await getNewAccessToken(refreshToken)
			// if(newToken) {
			// 	config.headers['Authorization'] = `Bearer ${newToken}`
			// 	localStorage.setItem('user-contracts', JSON.stringify({...userContracts, accessToken: newToken}))
			// 	return api(originalRequest)
			// }
			// } catch (e) {
			// 	console.error('Atempt to refresh token failed')
			// 	// TODO: make user logout request
			// 	window.location.href = '/sign-in'
			// }
		} else if (error.response.status === 403) {
			//store.dispatch(logout())

			// return Promise.reject(error)
			return null
		} else if (error.response.status === 400) {
			return Promise.reject(error)
		} else {
			errorMessage({
				content:
					'Ooops, ocorreu um erro. Já avisamos nossos engenheiros, por favor tente mais tarde.',
			})
		}
	}
)

export default api
